'use client';

import { numberFormat } from '@/utils/functions/numberFormat';
import { truncateString } from '@/utils/functions/stringFormat';
import { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';

export type Plan = {
  id: string;
  name: string;
  description: string;
  price: number;
  periodicity: string;
  is_active: boolean;
  modules: string[];
  actions: ReactNode;
};

export const planManagementColumns: ColumnDef<Plan>[] = [
  {
    accessorKey: 'plan_name',
    header: 'Plano',
    size: 250,
    cell: function PlanNameCell({ row }: { row: { original: Plan } }) {
      return <div className="whitespace-normal break-words w-[180px]">{row.original.name}</div>;
    },
  },
  {
    accessorKey: 'plan_description',
    header: 'Descrição',
    size: 300,
    cell: function PlanDescriptionCell({ row }: { row: { original: Plan } }) {
      return (
        <div className="whitespace-normal break-words w-[280px]">
          {truncateString(row.original.description, 32)}
        </div>
      );
    },
  },
  {
    accessorKey: 'plan_price',
    header: 'Preço',
    size: 250,
    cell: function PlanPriceCell({ row }: { row: { original: Plan } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {numberFormat.currency(row.original.price)}
        </div>
      );
    },
  },
  {
    accessorKey: 'plan_periodicity',
    header: 'Periodicidade',
    size: 250,
    cell: function PlanPeriodicityCell({ row }: { row: { original: Plan } }) {
      return (
        <div className="whitespace-normal break-words w-[250px]">{row.original.periodicity}</div>
      );
    },
  },
  {
    accessorKey: 'plan_status',
    header: 'Status',
    size: 250,
    cell: function PlanStatusCell({ row }: { row: { original: Plan } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          <div
            className={`w-fit px-2 py-1 rounded-md text-white ${
              row.original.is_active ? 'bg-green-600' : 'bg-red-600'
            }`}
          >
            {row.original.is_active ? 'Ativo' : 'Inativo'}
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: 'plan_features',
    header: 'Funcionalidades',
    size: 250,
    cell: function PlanModulesCell({ row }: { row: { original: Plan } }) {
      return (
        <div className="whitespace-normal break-words w-[250px]">{row.original.modules.length}</div>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: '',
    size: 60,
    cell: function ActionsCell({ row }: { row: { original: Plan } }) {
      return <div className="w-full flex justify-end">{row.original.actions}</div>;
    },
  },
];
